import selectFilesUrl from "@assets/select_files.png?url"
import selectFolderUrl from "@assets/select_folder.png?url"
import { ConfirmDialog } from "./ConfirmDialog"
import { useTranslation } from "react-i18next"

interface SelectFolderErrorDialogProps {
	onConfirm: () => void
}

export function SelectFolderErrorDialog({ onConfirm }: SelectFolderErrorDialogProps) {
	const { t } = useTranslation("components")
	return (
		<ConfirmDialog
			trackingViewName="folder_selection_failed"
			title={t("selectFolderErrorDialog.pleaseSelectAFolder")}
			embeddedComponent={
				<div className="space-y-3">
					<div className="flex items-center justify-center gap-4">
						<img
							className="mt-[20px] w-[190px]"
							src={selectFolderUrl}
							alt={t("selectFolderErrorDialog.selectAFolderInstead")}
						/>

						<div className="mx-6 h-[150px] w-px bg-base-700"></div>
						<img
							className="w-[190px]"
							src={selectFilesUrl}
							alt={t("selectFolderErrorDialog.selectingFilesIsNotSupported")}
						/>
					</div>
					<div className="pb-2 text-start text-sm">
						{t("selectFolderErrorDialog.yourImportFailedBecauseThe")}
					</div>
				</div>
			}
			primary={{
				title: t("common:action.ok"),
				handler: onConfirm,
			}}
		/>
	)
}
